export default "__VITE_ASSET__CnICboPC__"